.editIndustry {
    width: 100%;
    * #typeahead-industry-edit {
        transform: translateX(100%);
    }
}

.textInput {
    border: 2px solid #2075F4;
    border-radius: 4px;
    padding: 4px 8px;
    outline: none;
    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 16px;
    
    &:focus {
        border-color: #2075F4;
        box-shadow: 0 0 0 2px rgba(32, 117, 244, 0.2);
    }
}
